export default __webpack_public_path__ + "static/media/audio.d7d8283d.svg";